<template>
  <div class="chat w-100">
    <li class="clearfix ">
      <div class="message-data align-right">
        <div class="message " :class="replySide">
          <div class="d-inline" dir="ltr">
            <div class="message-data-time d-inline">
              <i class="fa fa-circle online text-dark"></i>
              {{ dateConverter(message.created_at) }}
            </div>
            <div class="message-data-name d-inline">
              {{ message.user.name }}
            </div>
          </div>
          <div class="pl-2">{{ message.text }}</div>

          <div class="mt-4">

            <a target="_blank" class="text-white" v-for="file in message.files" v-b-tooltip.hover :title="fileName(file)" :href="file.file">
              <b-icon class="h3 mx-1 cursor_pointer" icon="file-earmark-post-fill"></b-icon>
            </a>

          </div>

        </div>
      </div>
    </li>
  </div>
</template>

<script>
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "tableItems",
  props: ["message", "user"],
  data() {
    return {};
  },
  computed: {
    replySide() {
      if (this.message.user.id == this.user.id) {
        return 'float-right other-message'
      }
      return 'float-left my-message'
    }
  },
  methods: {
    dateConverter(date) {
      return dateConverter(date, "/", true);
    },
    fileName(file){
      return file.file.split('/').slice(-1)
    }
  },
  mounted() {
  },
};
</script>

<style scoped>
body {
  background: #c5ddeb;

  padding: 40px 0;
  color: white;
}

.container {
  margin: 0 auto;
  width: 750px;
  background: #444753;
  border-radius: 5px;
}

.people-list {
  width: 260px;
  float: left;
}

.people-list .search {
  padding: 20px;
}

.people-list input {
  border-radius: 3px;
  border: none;
  padding: 14px;
  color: white;
  background: #6a6c75;
  width: 90%;
  font-size: 14px;
}

.people-list .fa-search {
  position: relative;
  left: -25px;
}

.people-list ul {
  padding: 20px;
  height: 770px;
}

li {
  list-style: none;
}

.people-list ul li {
  padding-bottom: 20px;
  list-style: none;
}

.people-list img {
  float: left;
}

.people-list .about {
  float: left;
  margin-top: 8px;
}

.people-list .about {
  padding-left: 8px;
}

.people-list .status {
  color: var(--primary);
}

.chat {
  float: left;
  background: #f2f5f8;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  color: #434651;
}

.chat .chat-history {
  padding: 30px 30px 20px;
  border-bottom: 2px solid white;
  overflow-y: scroll;
  height: 575px;
}

.chat .chat-history .message-data {
  margin-bottom: 15px;
}

.chat .chat-history .message-data-time {
  color: #d8d9de;
  padding-left: 6px;
}

.chat .chat-history .message {
  color: white !important;
  padding: 18px 20px;
  line-height: 26px;
  font-size: 16px;
  border-radius: 7px;
  margin-bottom: 30px;
  width: 90%;
  position: relative;
}

.chat .chat-history .message:after {
  bottom: 97%;
  left: 8%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-bottom-color: var(--primary);
  border-width: 10px;
  margin-left: -10px;
}

.chat .chat-history .my-message {
  background: var(--primary);
}

.chat .chat-history .other-message {
  background: var(--secondary);
}

.chat .chat-history .other-message:after {
  border-bottom-color: var(--secondary);
  left: 90%;
}

.chat .chat-message {
  padding: 30px;
}

.chat .chat-message textarea {
  width: 100%;
  border: none;
  padding: 10px 20px;
  margin-bottom: 10px;
  border-radius: 5px;
  resize: none;
}

.chat .chat-message .fa-file-o,
.chat .chat-message .fa-file-image-o {
  font-size: 16px;
  color: gray;
  cursor: pointer;
}

.chat .chat-message button {
  float: right;
  color: var(--primary);
  font-size: 16px;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  font-weight: bold;
  background: #f2f5f8;
}

.chat .chat-message button:hover {
  color: var(--primary);
}

.online,
.offline,
.me {
  margin-right: 3px;
  font-size: 10px;
}

.online {
  color: var(--primary);
}

.offline {
  color: #e38968;
}

.me {
  color: var(--primary);
}

.align-left {
  text-align: left;
}

.align-right {
  text-align: right;
}

.float-right {
  float: right;
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}

.chat-img {
  height: 80px;
}

.border-bottom-header-chat {
  border: 1px solid #cfcfcf;
  background: #dbdbdb;
}

.cursor_pointer {
  cursor: pointer;
}

</style>
